import { useOutletContext } from 'react-router-dom'

import { SettingsEmployeeGroupFragment } from 'generated/resources/graphql'

import MakeMainModal from 'modules/legal_entities/components/EmployeeGroups/MakeMain'
import { useOnClose } from 'modules/legal_entities/hooks/useOnClose'

const MakeMainPage = () => {
  const { employeeGroup } = useOutletContext<{ employeeGroup: SettingsEmployeeGroupFragment }>()
  const onClose = useOnClose(employeeGroup.legalEntityId)

  return <MakeMainModal onClose={onClose} employeeGroup={employeeGroup} />
}

export default MakeMainPage
